import { formatDate, getCookie, simulateAsyncOperation, throttle } from 'mmbclient/Common/CommonFunctions';
import { getClientBalance } from 'mmbclient/Common/CommonRazorPay';
import { checkSession, getAllClients } from 'mmbclient/Common/CommonService';
import { AD, API_PATH, APP_TYPE_COOKIE_NAME, EP, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, LOGIN_SESSION_NAME, LOGIN_THROTTLE_TIME, PAGE_LOADING_TIME, STOCK_INCOMING, US, USER_TYPE_COOKIE_NAME, WALLET } from 'mmbclient/Common/CommonVariable';
import React, { useContext, useEffect, useState } from 'react';
import * as XLSX from 'xlsx';

function StockIncomingController(store) {

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [client, setClient] = useState("All");
    const [clientOption, setClientOption] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [modalMessage, setModalMessage] = useState('');
    const [modalType, setModalType] = useState('');
    const [showModal, setShowModal] = useState(false);
    const wallet = useContext(WALLET);

    useEffect(()=>{

        const fetchData = async() =>{
            setLoading(true);
            try{
                if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
               await Promise.all([
                 loadAllClients(store),
                simulateAsyncOperation(PAGE_LOADING_TIME),
               ])
            }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                await Promise.all([
                    simulateAsyncOperation(PAGE_LOADING_TIME),
                ])
            }
            }catch(error){
                console.log(error);
            }finally{
                setLoading(false);
            }
        }

        fetchData();
    },[])

    const loadAllClients = async(store)=>{
        const response = await getAllClients(store);
        let clientList = [];
        clientList.push("All")
        for(let i of response){
            clientList.push(i.client_name.toUpperCase() + " | " + i.client_code.toUpperCase());
        }

        setClientOption(clientList);
        setClient(clientList[0]);
    }

    const loggerFunc = () => {
            checkSession(store);
            getClientBalance(wallet);
        }
    
    const betterLoggerFunction = throttle(loggerFunc, LOGIN_THROTTLE_TIME);

    const handleClick = async()=>{
        if(endDate<startDate){
            setModalMessage("End date cannot be erlier than start date!");
            setModalType("primary");
            setShowModal(true);
            return;
        }

        checkSession(store)
        if(!getCookie(LOGIN_SESSION_NAME)){
            return;
        }
        console.log("start "+startDate.toISOString().slice(0,10));
        console.log("end "+endDate.toISOString().slice(0,10));

        setLoading(true)

        try{

            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            if(c.length === 4){
                const Data = "Data";
                let query = {};
                if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
                    if(client === "All"){
                        query = {"userKey":c[0], "userType": cookieUserType, "clientCode":"All", "beanName":Data, "fromDate": startDate.toISOString().slice(0,10), "toDate":endDate.toISOString().slice(0,10)}
                    }else{
                        const clientCode = client.split("|")[1].trim();
                        query = {"userKey":c[0], "userType": cookieUserType, "clientCode":clientCode, "beanName":Data, "fromDate": startDate.toISOString().slice(0,10), "toDate":endDate.toISOString().slice(0,10)}
                    }
                }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                    query = {"userKey":c[0], "userType": cookieUserType, "clientCode":c[1], "beanName":Data, "fromDate": startDate.toISOString().slice(0,10), "toDate":endDate.toISOString().slice(0,10)}
                }

                const responseOption = {
                    method: "POST",
                    headers:{"Content_Type":"application/json"},
                    body: new URLSearchParams({
                          query: JSON.stringify(query)
                        })
                }

                const path = API_PATH + STOCK_INCOMING + "getstock"; 
                const response = await fetch(path, responseOption);
                const data = await response.json();
                const res = JSON.parse(data)[0].Data;

                if(res.length>0 && res !== ("Result Not Found")){
                    setData(res);
                    console.log(res)
                }else{
                    setData([]);
                }
            }
        }catch(error){
            console.log(error);
        }finally{
            setLoading(false);
        }
    }

    const escapeCsvValue = (value) => {
        if (typeof value === 'string') {
            // Replace commas, newlines, and carriage returns with semicolons
            value = value.replace(/[,]/g, ';')    // Replace commas with semicolons
                .replace(/[\n]/g, ';')   // Replace newlines with semicolons
                .replace(/[\r]/g, ';');  // Replace carriage returns with semicolons
            // Optionally, escape double quotes by replacing them with two double quotes
            value = value.replace(/"/g, '""');
        }
        return value;
    };

    const exportToCSV = ()=>{
        if(Array.isArray(data) && data.length === 0){
            setModalMessage("No Data Found!");
            setModalType("primary");
            setShowModal(true);
            return;
        }
        const csvRows = [];

        let header;

        if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
            header = [
                "SNo",
                "Client",
                "Network",
                "Awb Range",
                "Awb No",
                "In Date",
                "Expiry Date"
            ]
        }else{
            header = [
                "SNo",
                "Network",
                "Awb Range",
                "Awb No",
                "In Date",
                "Expiry Date"
            ]
        }

        csvRows.push(header.join(','));

        if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
            data.forEach((item,index)=>{
                const value = [
                    escapeCsvValue(index+1 || ""),
                    escapeCsvValue(item.client_name || ""),
                    escapeCsvValue(item.network_name + " | " + item.network_code || ""),
                    escapeCsvValue(item.original_range || ""),
                    escapeCsvValue(item.awb_no || ""),
                    escapeCsvValue(item.in_date || ""),
                    escapeCsvValue(item.exp_date || "")
                ];
                csvRows.push(value.join(','));
            })
        }else{
            data.forEach((item,index)=>{
                const value = [
                    escapeCsvValue(index+1 || ""),
                    escapeCsvValue(item.network_name + " | " + item.network_code || ""),
                    escapeCsvValue(item.original_range || ""),
                    escapeCsvValue(item.awb_no || ""),
                    escapeCsvValue(item.in_date || ""),
                    escapeCsvValue(item.exp_date || "")
                ];
                csvRows.push(value.join(','));
            })
        }
        const csvString = csvRows.join('\n');
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'data.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


    const exportToExcel = () => {

        if(Array.isArray(data) && data.length === 0){
            setModalMessage("No Data Found!");
            setModalType("primary");
            setShowModal(true);
            return;
        }

        setLoading(true);

        let ws;
        if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
            ws = XLSX.utils.json_to_sheet(data.map((item, index)=>({
                SNo:index +1,
                Client : item.client_name || "",
                Network : item.network_name + " | " + item.network_code || "",
                "Awb Range": item.original_range || "",
                "Awb No": item.awb_no,
                "In Date": item.in_date || "",
                "Expiry Date": item.exp_date || "" 
            })))
        }else{
            ws = XLSX.utils.json_to_sheet(data.map((item, index)=>({
                SNo:index +1,
                "Awb Range": item.original_range || "",
                Network : item.network_name + " | " + item.network_code || "",
                "Awb No": item.awb_no,
                "In Date": item.in_date || "",
                "Expiry Date": item.exp_date || "" 
            })))
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb,ws,"Data");

        XLSX.writeFile(wb,"Data.xlsx")
        setLoading(false);
    }

    const [currentPage, setCurrentPage] = useState(1);
    const [searchItem, setSearchItem] = useState("");
    const itemPerPage = 20;

    const filteredData = Array.isArray(data)? data.filter(item =>{
                const lowerCaseSearchTerm = searchItem.toLowerCase();

                return(
                    String(item?.client_name)?.toLowerCase().includes(lowerCaseSearchTerm) ||
                    String(item?.original_range)?.toLowerCase().includes(lowerCaseSearchTerm) ||
                    String(item?.awb_no)?.toLowerCase().includes(lowerCaseSearchTerm) ||
                    String(item?.in_date)?.toLowerCase().includes(lowerCaseSearchTerm) ||
                    String(item?.exp_date)?.toLowerCase().includes(lowerCaseSearchTerm)
                );
        }) : [];

        const totalPages = Math.ceil(filteredData.length/itemPerPage);
            
                // Get current items
        const indexOfLastItem = currentPage * itemPerPage;
        const indexOfFirstItem = indexOfLastItem - itemPerPage;
        const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);




  return {currentItems, currentPage, setCurrentPage, totalPages, itemPerPage, startDate, setStartDate, endDate, setEndDate, client, setClient, clientOption, loading, showModal ,setShowModal, modalType, modalMessage, betterLoggerFunction, searchItem, setSearchItem, handleClick, exportToCSV, exportToExcel}
}

export default StockIncomingController
